import styled, { createGlobalStyle, css } from 'styled-components';

const DeliveryBarStyle = styled.div`
	--offsetTop: var(--sp1x);
	--widthSelector: 25vw;
	--layoutGap: var(--sp2x);
	--radiusBorder: var(--sp4x);
	--paddingSelector: var(--sp2-5x);
	--gapSelector: var(--sp1-5x);
	--fontSizeSelector: 18px;
	--fontSizeIcon: var(--sp3x);
	--maxHeightDropdown: var(--sp40x);
	--paddingDropdownItem: var(--sp1-5x);
	--gapItemInfo: var(--sp0-5x);
	--paddingDropdown: var(--sp1-5x);

	--distanceTopAll: var(--sp3x);
	--gapDropdownItem: var(--sp1x);

	position: absolute;
	top: calc(var(--distanceTopAll));
	left: 50%;
	transform: translateX(-50%);
	z-index: 5000;
	display: flex;
	flex-direction: column;
	align-items: center;
	pointer-events: auto;
	cursor: default;

	&.is-hero-intro-pending {
		opacity: 0;
		pointer-events: none;
	}

	.icon-pin,
	.icon-arrow,
	.location-icon {
		font-size: var(--fontSizeIcon);
		color: var(--neutral1000);
	}

	.icon-arrow {
		transform: rotate(90deg);
		transition: transform var(--trTime) ease-out;
		margin-left: auto;

		&.is-open {
			transform: rotate(270deg);
		}
	}

	.delivery-bar-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--layoutGap);

		.outside-wrapper-tabs {
			width: 100%;
			display: flex;
			justify-content: center;

			.wrapper-tabs {
				display: flex;
				gap: var(--sp0-5x);
				padding: var(--sp0-5x);
				border-radius: 100px;
				background: var(--neutral1000);
				width: fit-content;

				button {
					border: none !important;
				}
			}
		}
	}

	input,
	.selector-text {
		font-size: var(--fontSizeSelector) !important;
		line-height: var(--lineHeightS) !important;

		&::placeholder {
			line-height: var(--lineHeightS) !important;
			font-size: var(--fontSizeSelector) !important;
		}
	}

	.selector-text {
		flex: 1;
		min-width: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.wrapper-selector {
		position: relative;
		width: var(--widthSelector);

		.selector-button,
		.selector-field {
			display: flex;
			align-items: center;
			gap: var(--gapSelector);
			width: 100%;
			padding: var(--paddingSelector);
			border-radius: var(--radiusBorder);
			background: var(--mainColor);
			cursor: pointer;
		}
	}

	.selector-field {
		.selector-input-wrap {
			flex: 1;
			min-width: 0;
			margin: 0;

			.affix-wrapper,
			.base-input,
			input {
				padding: 0 !important;
				border: none;
				background: transparent;
				box-shadow: none;
				border-radius: 0 !important;
			}
		}
	}

	.wrapper-dropdown {
		position: absolute;
		top: calc(100% + var(--sp1x));
		left: 0;
		right: 0;
		z-index: 10;
		padding: var(--paddingDropdown);
		max-height: var(--maxHeightDropdown);
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: contain;
		border-radius: var(--sp2x);
		background: var(--mainColor);
		display: flex;
		flex-direction: column;
		gap: var(--gapDropdownItem);
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;

		.icon-pin {
			transform: translateY(calc((var(--p3) - var(--p3) * var(--lineHeight)) / -2));
		}
	}

	.dropdown-item,
	.location-button {
		width: 100%;
		display: flex;
		gap: var(--gapSelector);
		padding: var(--paddingDropdownItem);
		border-radius: var(--sp2x);
		cursor: pointer;

		.item-info {
			display: flex;
			flex-direction: column;
			gap: var(--gapItemInfo);
		}

		&.active {
			background: var(--neutral25);
		}
	}

	.location-button {
		display: flex;
		align-items: center;
	}

	.item-hours {
		display: flex;
		align-items: center;
		gap: var(--sp1x);
	}

	.item-status {
		color: var(--success1000);
	}

	.empty-state {
		padding: var(--sp3x) var(--sp2-5x);
		text-align: center;
	}

	&.is-shop-fulfillment-bar {
		position: relative;
		top: 0;
		left: auto;
		transform: none;
		z-index: 2;
		background-color: transparent;
		width: 100%;
		padding: 0;
		pointer-events: auto;

		.sticky-delivery-root {
			position: relative;
			width: 100%;
		}

		.fulfillment-sticky-trigger {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: var(--sp0-5x);
			width: 100%;
			padding: var(--sp1-5x) 0;
			background: transparent;
			border: none;
			cursor: pointer;
			text-align: left;
			color: var(--mainColor);
		}

		.fulfillment-sticky-trigger.is-home-style {
			flex-direction: row;
			align-items: center;
			gap: var(--gapSelector);
			padding: var(--paddingSelector);
			border-radius: var(--radiusBorder);
			background: var(--mainColor);
			color: var(--backgroundColor);
		}

		.fulfillment-sticky-trigger.is-home-style .fulfillment-sticky-location {
			flex: 1;
			min-width: 0;
			font-size: var(--fontSizeSelector);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.fulfillment-sticky-trigger.is-home-style .fulfillment-sticky-pin,
		.fulfillment-sticky-trigger.is-home-style .fulfillment-sticky-chevron {
			flex-shrink: 0;
			font-size: var(--fontSizeIcon);
			color: var(--backgroundColor);
		}

		.fulfillment-sticky-type {
			opacity: 0.85;
		}

		.fulfillment-sticky-row {
			display: flex;
			align-items: center;
			gap: var(--sp1x);
			width: 100%;
			min-width: 0;
		}

		.fulfillment-sticky-pin {
			flex-shrink: 0;
			font-size: var(--sp2-5x);
		}

		.fulfillment-sticky-location {
			flex: 1;
			min-width: 0;
			font-size: var(--sp2x);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.fulfillment-sticky-separator {
			flex-shrink: 0;
			width: 2px;
			height: var(--sp2x);
			background: var(--neutral600);
			border-radius: 1px;
		}

		.fulfillment-sticky-time {
			flex-shrink: 0;
			font-size: var(--p4);
			white-space: nowrap;
		}

		.fulfillment-sticky-chevron {
			flex-shrink: 0;
			font-size: var(--sp2x);
			margin-left: auto;
			color: var(--mainColor);
		}
	}

	&.is-shop-fulfillment-bar {
		padding: 0 var(--contPaddingLR);
		border-top: 1px solid var(--neutral800);
	}

	&.is-shop-fulfillment-bar:not(.has-fulfillment-selection) {
		padding-top: var(--sp1x);
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.dropdown-item {
				&:hover {
					background-color: var(--neutral25);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--offsetTop: var(--sp1x);
		--widthSelector: 30vw;
		--layoutGap: var(--sp2x);
		--radiusBorder: var(--sp4x);
		--paddingSelector: var(--sp2x);
		--gapSelector: var(--sp1x);
		--fontSizeSelector: var(--sp2x);
		--fontSizeIcon: var(--sp2x);
		--maxHeightDropdown: 320px;
		--paddingDropdownItem: var(--sp1-5x);
		--gapItemInfo: var(--sp0-5x);
		--paddingDropdown: var(--sp1-5x);

		--distanceTopAll: var(--sp2x);
		--gapDropdownItem: var(--sp1x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--maxHeightDropdown: var(--sp35x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--widthSelector: 35vw;
		--maxHeightDropdown: var(--sp30x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--widthSelector: 50vw;
	}

	/* //! Collapsible header layout (≤1280) */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.collapsibleHeaderMaxMin}) {
		&.delivery-bar-wrapper:not(.is-shop-fulfillment-bar) {
			--widthSelector: 100%;
			width: 100%;
			padding: 0 var(--contPaddingLR);

			form {
				width: 100%;
			}
		}

		.sticky-delivery-root {
			position: relative;
			width: 100%;
		}

		.sticky-pill {
			position: relative;
			z-index: 2;
		}

		&.is-sticky-portal .sticky-pill {
			display: flex;
			align-items: center;
			gap: var(--gapSelector);
			width: 100%;
			padding: var(--paddingSelector);
			border-radius: var(--radiusBorder);
			background: var(--mainColor);
			border: none;
			cursor: pointer;
			text-align: left;
		}

		.sticky-delivery-panel {
			position: absolute;
			top: calc(100% + var(--sp1x));
			left: 0;
			right: 0;
			z-index: 2;
			background: var(--mainColor);
			border-radius: var(--sp3x);
			padding: var(--sp4x) var(--sp2x) var(--sp4x);
			max-height: min(85vh, 640px);
			overflow: visible;
			-webkit-overflow-scrolling: touch;
			animation: stickyPanelIn var(--trTime) ease forwards;
		}

		&.is-sticky-portal {
			position: fixed !important;
			top: var(--header-total-height, calc(var(--headerBannerHeight) + var(--headerFixedHeight)));
			left: 0;
			right: 0;
			z-index: 1001;
			background-color: var(--neutral1000);
			padding: var(--sp1-5x) var(--contPaddingLR);
			align-items: stretch;
			animation: stickyFadeIn 0.3s ease-out forwards;
		}
	}

	/* //! Mobile — hero full width (≤768) */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--widthSelector: 100%;
		width: 100%;
		padding: 0 var(--contPaddingLR);

		form {
			width: 100%;
		}
	}

	@keyframes stickyPanelIn {
		from {
			opacity: 0;
			transform: translateY(var(--sp2x));
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes stickyFadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export const StickyDeliveryGlobalStyle = createGlobalStyle`${css`
	.sticky-delivery-backdrop {
		position: fixed;
		inset: 0;
		/* Above the floating burger-menu button (z-index: 99999) so it doesn't
		 * poke through the backdrop while the delivery panel is open. */
		z-index: 10000;
		background: rgba(0, 0, 0, 0.45);
	}

	body.has-mobile-header-layout .is-sticky-portal,
	body.has-mobile-header-layout .shop-delivery-panel-host {
		transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
		transition: none;
	}

	body.is-header-animating.has-mobile-header-layout .is-sticky-portal,
	body.is-header-animating.has-mobile-header-layout .shop-delivery-panel-host {
		transition: transform var(--trTime) ease-out;
		will-change: transform;
	}

	body.is-header-nav-hidden.has-mobile-header-layout .is-sticky-portal,
	body.is-header-nav-hidden.has-mobile-header-layout .shop-delivery-panel-host {
		transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
		-webkit-transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
	}

	@media (prefers-reduced-motion: reduce) {
		body.is-header-animating.has-mobile-header-layout .is-sticky-portal,
		body.is-header-animating.has-mobile-header-layout .shop-delivery-panel-host {
			transition: none;
		}
	}

	/* Host wrapper for shop delivery panel portal — positions it below header */
	.shop-delivery-panel-host {
		position: fixed !important;
		top: var(--header-total-height, calc(var(--headerBannerHeight) + var(--headerFixedHeight))) !important;
		left: 0 !important;
		right: 0 !important;
		z-index: 10003 !important;
		padding: 0 var(--contPaddingLR);
		align-items: stretch;

		.sticky-delivery-panel {
			position: relative !important;
			top: 0 !important;
			background: var(--mainColor);
			border-radius: var(--sp3x);
			padding: var(--sp4x) var(--sp2x) var(--sp4x);
			max-height: min(75vh, 600px);
			overflow: visible;
			-webkit-overflow-scrolling: touch;
		}
	}

	body.delivery-sticky-panel-open {
		header,
		header .shop-fulfillment-slot-inner.is-fulfillment-fixed {
			z-index: 100002 !important;
		}

		.is-sticky-portal {
			z-index: 100002 !important;
		}

		.is-sticky-portal .sticky-delivery-root,
		.is-shop-fulfillment-bar .sticky-delivery-root {
			z-index: 100003;
		}

		/* Footer's scroll-trigger sets this inline (burgerMenu.style.opacity),
		 * which beats a plain CSS rule — !important is required to win. Kept as
		 * a belt-and-suspenders on top of the z-index bump above. */
		#burger-menu-visible {
			opacity: 0 !important;
			pointer-events: none !important;
		}
	}
`}`;

export default DeliveryBarStyle;
